import { OptionType } from "../../shared/components/BaseAsyncPaginate";
import { getPaginatedByNameIndustrySpecialists } from "pages/admin-app/industry-specialist/services/industry-specialist-service";
import {
  GetIndustrySpecialistsResponse,
  IndustrySpecialist,
} from "pages/admin-app/industry-specialist/models/response/get-industry-specialists-response";
import { createLoadOptions } from "../../service/createLoadOptions";

const fetchIndustrySpecialists = async (
  page: number,
  perPage: number,
  searchQuery?: string
): Promise<GetIndustrySpecialistsResponse> => {
  return getPaginatedByNameIndustrySpecialists({ page, perPage, searchQuery });
};

const industrySpecialistMapper = (spec: IndustrySpecialist): OptionType => ({
  value: spec.id,
  label: spec.name,
});

export const loadIndustrySpecialists = createLoadOptions(
  fetchIndustrySpecialists,
  industrySpecialistMapper
);
